const PieceJointeMixin = {
    methods: {
        hasThumbnail(attachment) {
            return attachment.thumbnail !== null && attachment.thumbnail !== undefined;
        }
    }
}
export default PieceJointeMixin;